<template>
    <div :class="divClass"></div>
  </template>
  
  <script>
  export default {
    props: {
      block: {
        type: String,
        required: false,
        default: 'hubspotForm'
      },
      region: {
        type: String,
        required: false,
        default: 'na1'
      },
      portalId: {
        type: String,
        required: false,
        default: "7988635"
      },
      formId: {
        type: String,
        required: false,
        default: "f1a6bda9-7ed5-44d1-b066-e708377b9ab4"
      },
      uniqueId: {
        type: String,
        required: false,
        default: null
      },
      options: {
        type: Object,
        required: false,
        default() {
          return {};
        }
      },
      successUrl: {
        type: String,
        required: false,
        default: ""
      },
      download: {
        type: Boolean,
        required: false,
        default: false
      },
      officeValue: {
        type: String,
        required: false,
        default: ""
      }
    },
    created() {
      console.log("Loading hubspot form.");
    },
    async mounted() {
      if (!window.hbspt) {
        await this.loadHubspotApi();
      }
      this.initializeForm();
      this.listenForFormRender();
      this.listenForSuccess();
    },
    computed: {
      divClass() {
        let classes = `js-form-${this.formId} ${this.block}__formContainer`;
        if (this.uniqueId) {
          classes += ` unique-form-id-${this.uniqueId}`;
        }
        return classes;
      },
  
      formObject() {
        let targetClass = `.js-form-${this.formId}`;
        if (this.uniqueId) {
          targetClass += `.unique-form-id-${this.uniqueId}`;
        }
  
        return {
          region: this.region,
          portalId: this.portalId,
          formId: this.formId,
          target: targetClass,
          cssClass: `${this.block}__form`,
          cssRequired: '',
          ...this.options
        };
      }
    },
    methods: {
      loadHubspotApi() {
        return new Promise((resolve) => {
          const script = document.createElement("script");
          script.src = "https://js.hsforms.net/forms/v2.js";
          document.body.appendChild(script);
          script.addEventListener("load", resolve);
        });
      },
  
      initializeForm() {
        hbspt.forms.create(this.formObject);
      },
  
      listenForSuccess() {
        window.addEventListener('message', event => {
          if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
            if (this.download) {
              this.downloadFile();
            }
          }
        });
      },
  
      listenForFormRender() {
        window.addEventListener('message', event => {
          if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
            this.setOfficeValue();
            this.$emit('ready');
          }
        });
      },
  
    setOfficeValue() {
        const selectElement = document.querySelector(`.js-form-${this.formId} select[name="beacon_hill_office_city"]`);
        if (selectElement) {
            if (this.officeValue) {
                const normalize = (str) => str.replace(/\s+/g, '').toLowerCase();
                const normalizedOfficeValue = normalize(this.officeValue);
        
                const optionToSelect = Array.from(selectElement.options).find(option => {
                return normalize(option.value) === normalizedOfficeValue;
                });
        
                if (optionToSelect) {
                optionToSelect.selected = true;
                const event = new Event('change', { bubbles: true });
                selectElement.dispatchEvent(event);
                }
            } else {
                selectElement.selectedIndex = 0;
            }
        }
    },
  
      resetForm() {
        const selectElement = document.querySelector(`.js-form-${this.formId} select[name="beacon_hill_office_city"]`);
        if (selectElement) {
          selectElement.selectedIndex = 0;
        }
      },
  
      downloadFile() {
        if (this.successUrl) {
          const link = document.createElement("a");
          link.href = this.successUrl;
          link.target = "_blank";
          link.download = this.successUrl;
          link.click();
        } else {
          alert("No file available to download.");
        }
        this.$emit('close');
      }
    }
  };
  </script>
  